module.exports = __webpack_public_path__ + "img/smiley J.c9f55738.svg";